import INTEGRATION_SUPPORT_MATRIX from './integration_support.json'

export { INTEGRATION_SUPPORT_MATRIX }

export const INTEGRATION_MAP = Object.fromEntries(
  INTEGRATION_SUPPORT_MATRIX.map((integration) => [
    integration.key,
    integration,
  ])
)

export const FEATURE_FLAG_DEFAULTS = {
  AUTONOMY_WORKER_ENABLED: false,
  ENABLE_LINKEDIN_ARTICLE_PUBLISHING: false,
  ENABLE_NOTION_SYNC: false,
  ENABLE_LIVE_POSTING: false,
}

function parseFeatureFlag(value, defaultValue) {
  if (value == null || value === '') return defaultValue
  return ['1', 'true', 'yes', 'on'].includes(String(value).toLowerCase())
}

export function getFeatureFlags(env = {}) {
  return {
    autonomyWorkerEnabled: parseFeatureFlag(
      env.AUTONOMY_WORKER_ENABLED,
      FEATURE_FLAG_DEFAULTS.AUTONOMY_WORKER_ENABLED
    ),
    enableLinkedinArticlePublishing: parseFeatureFlag(
      env.ENABLE_LINKEDIN_ARTICLE_PUBLISHING,
      FEATURE_FLAG_DEFAULTS.ENABLE_LINKEDIN_ARTICLE_PUBLISHING
    ),
    enableNotionSync: parseFeatureFlag(
      env.ENABLE_NOTION_SYNC,
      FEATURE_FLAG_DEFAULTS.ENABLE_NOTION_SYNC
    ),
    enableLivePosting: parseFeatureFlag(
      env.ENABLE_LIVE_POSTING,
      FEATURE_FLAG_DEFAULTS.ENABLE_LIVE_POSTING
    ),
  }
}

function getFlagStateForIntegration(integration, flags) {
  if (!integration.featureFlag) return true
  if (integration.featureFlag === 'AUTONOMY_WORKER_ENABLED')
    return flags.autonomyWorkerEnabled && flags.enableLivePosting
  if (integration.featureFlag === 'ENABLE_LINKEDIN_ARTICLE_PUBLISHING')
    return flags.enableLinkedinArticlePublishing
  if (integration.featureFlag === 'ENABLE_NOTION_SYNC')
    return flags.enableNotionSync
  if (integration.featureFlag === 'ENABLE_LIVE_POSTING')
    return flags.enableLivePosting
  return true
}

export function getIntegrationAvailability(integration, env = {}) {
  const flags = getFeatureFlags(env)
  const flagEnabled = getFlagStateForIntegration(integration, flags)
  const configured = (integration.requiresEnv || []).every((key) => !!env[key])

  return {
    ...integration,
    enabled: integration.status !== 'unsupported' && flagEnabled,
    configured,
    available:
      integration.status !== 'unsupported' && flagEnabled && configured,
  }
}

export function getRuntimeIntegrationSupport(env = {}) {
  return Object.fromEntries(
    INTEGRATION_SUPPORT_MATRIX.map((integration) => [
      integration.key,
      getIntegrationAvailability(integration, env),
    ])
  )
}

export function getIntegration(key) {
  return INTEGRATION_MAP[key] || null
}

export default {
  INTEGRATION_SUPPORT_MATRIX,
  INTEGRATION_MAP,
  FEATURE_FLAG_DEFAULTS,
  getFeatureFlags,
  getRuntimeIntegrationSupport,
  getIntegrationAvailability,
  getIntegration,
}
